import { render, staticRenderFns } from "./detailsModel1.vue?vue&type=template&id=96a9d004&scoped=true"
import script from "./detailsModel1.vue?vue&type=script&lang=js"
export * from "./detailsModel1.vue?vue&type=script&lang=js"
import style0 from "./detailsModel1.vue?vue&type=style&index=0&id=96a9d004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a9d004",
  null
  
)

export default component.exports